// extracted by mini-css-extract-plugin
export default {"fullFrame":"Dynmap_fullFrame__X2vR-"};